export function base64Decode(value: string) {
    return Uint8Array.from(atob(value), (c) => c.charCodeAt(0));
}
